var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoniczka1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 635.83 812.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:20px;}.cls-2{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "doniczka1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_3",
    "data-name": "Warstwa 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1034.7,961h322.46c147.63-230,96.15-376,96.15-376H939.52S895.81,775,1034.7,961Z",
    transform: "translate(-879.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1648,560",
    transform: "translate(-879.16 -158.52)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_6",
    "data-name": "Warstwa 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1367.73,584.78l-68.57-.76c6.79-10.71,13.85-21.39,21.13-31.95,74.76-108.42,196.93-193.64,183.71-164.93-48,104.33-22.64,121.39-67.32,197.79Z",
    transform: "translate(-879.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1026.43,584.78,1095,584c-6.78-10.71-13.84-21.39-21.12-31.95C999.11,443.65,876.93,358.43,890.15,387.14c48.05,104.33,22.65,121.39,67.33,197.79Z",
    transform: "translate(-879.16 -158.52)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_4",
    "data-name": "Warstwa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1145.65,585c-32.08-38.82-54.18-108-44.71-186.63,13.28-110.23,97.69-272.26,101.84-219.63,6,76.68,97.28,116.23,101.83,219.63,3.47,78.76-16.8,147.86-46.85,186.63",
    transform: "translate(-879.16 -158.52)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_7",
    "data-name": "Warstwa 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M993.19,457.76",
    transform: "translate(-879.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M995.19,457.76q-.11-5.38.28-11c6.8-101.07-17.59-179.16-16.16-184.77,7.86-30.93,81,41.89,121.43,126.51",
    transform: "translate(-879.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1410.87,446.78",
    transform: "translate(-879.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1285,584",
    transform: "translate(-879.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1416.87,438.78C1410.06,337.71,1434.45,259.62,1433,254c-8.17-32.11-86.67,47.57-125.9,136.21-.66,1.5-1.32,3-2,4.51",
    transform: "translate(-879.16 -158.52)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_9",
    "data-name": "Warstwa 9"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 209.84,
    y1: 426.48,
    x2: 209.84,
    y2: 641.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 268.84,
    y1: 425.48,
    x2: 268.84,
    y2: 601.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 149.84,
    y1: 425.48,
    x2: 149.84,
    y2: 601.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 322.84,
    y1: 425.48,
    x2: 322.84,
    y2: 565.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.84,
    y1: 425.48,
    x2: 95.84,
    y2: 565.48
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoniczka1);
export default __webpack_public_path__ + "static/media/doniczka1.c117363f9ff0a2b9d9cc351a0f0742eb.svg";
export { ForwardRef as ReactComponent };